export default "__VITE_ASSET__1KpcmkKdAUGbwiv0oOVLMw__"